import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { CertificateDialogComponent } from './components/dialogs/edit-certificate-dialog/certificate-dialog.component';
import { UserCourseCertificatesListComponent } from './components/list/user-course-certificates-list.component';
import { CertificateRecordApiService } from './services/certificate-record.api-service';
import { CertificateRecordService } from './services/certificate-record.service';
import { CertificationModule } from '../certifications/certification.module';

@NgModule({
    declarations: [UserCourseCertificatesListComponent, CertificateDialogComponent],
    imports: [
        MaxBrainSharedModule,
        FormsModule,
        MatTableModule,
        MatTooltipModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSortModule,
        MatInputModule,
        MatCheckboxModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        CertificationModule,
    ],
    exports: [UserCourseCertificatesListComponent, CertificateDialogComponent],
    providers: [CertificateRecordService],
})
export class CertificateRecordModule {
    static forRoot(): ModuleWithProviders<CertificateRecordModule> {
        return {
            ngModule: CertificateRecordModule,
            providers: [CertificateRecordApiService],
        };
    }
}
